
const TopBanner = (props) => {

    return ( 
    <> <div
        className="bg-contact-background  w-full h-[500px] bg-cover bg-no-repeat border-t border-t-borderT pt-8 mb-28">
       <div className="flex justify-center">
       <span className="text-nextColor font-IRANYekanExtra text-3xl text-center mt-28">
       {
        props.children
       }
       </span>
       </div>
     
    </div>
     </>
    )
}

export default TopBanner;